import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { patientEntitlementsTranslationKeys } from '../../translations';
import { mapPatientEntitlementTypeToEntitlementType } from '../patientEntitlements.utils';
import { PatientEntitlementTypeSelectorForm } from '../typeSelector/PatientEntitlementTypeSelectorForm';

import { PatientEntitlementCreateForm } from './PatientEntitlementCreateForm';
import { OnPatientEntitlementDocumentCreated } from './PatientEntitlementCreateForm.types';

type PatientEntitlementCreateModalProps = {
   readonly patientId: Patient['id'];
   readonly onCancel: VoidFunction;
   readonly onPatientEntitlementsDocumentCreated: OnPatientEntitlementDocumentCreated;
};

export const PatientEntitlementCreateModal = (props: PatientEntitlementCreateModalProps): JSX.Element => {
   return (
      <Modal
         title={patientEntitlementsTranslationKeys.addAdditionalEntitlement}
         onCloseRequest={props.onCancel}
         animateVisibility
         width={ModalWidth.WIDE}
         testId={'patientEntitlementCreate'}
         shouldCloseOnEsc={false}
         shouldCloseOnOverlayClick={false}
         visible
      >
         <PatientEntitlementTypeSelectorForm patientId={props.patientId}>
            {({ submit, selectedPatientEntitlementType }) => {
               if (!selectedPatientEntitlementType) {
                  return (
                     <>
                        <ModalConfirmButton
                           label={patientEntitlementsTranslationKeys.addEntitlement}
                           onClick={submit}
                        />
                        <ModalCancelButton label={commonTranslationKeys.cancel} onClick={props.onCancel} />
                        <ModalCloseButton onClick={props.onCancel} />
                     </>
                  );
               }

               const selectedEntitlementType = mapPatientEntitlementTypeToEntitlementType(
                  selectedPatientEntitlementType
               );

               return (
                  <PatientEntitlementCreateForm
                     patientId={props.patientId}
                     entitlementType={selectedEntitlementType}
                     onPatientEntitlementsDocumentCreated={props.onPatientEntitlementsDocumentCreated}
                  >
                     {({ patientEntitlementCreate, shouldConfirmExit }) => (
                        <>
                           <ModalConfirmButton
                              label={patientEntitlementsTranslationKeys.addEntitlement}
                              onClick={patientEntitlementCreate}
                           />
                           <ModalCancelButton
                              label={commonTranslationKeys.cancel}
                              onClick={props.onCancel}
                              shouldConfirmExit={shouldConfirmExit}
                           />
                           <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={shouldConfirmExit} />
                        </>
                     )}
                  </PatientEntitlementCreateForm>
               );
            }}
         </PatientEntitlementTypeSelectorForm>
      </Modal>
   );
};
